var React = require('react');

function Hamburger (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")),React.createElement("title",{"key":1},"navigation-menu"),React.createElement("path",{"className":"a","d":"M21 7H3M21 12H3M21 17H3","key":2})]);
}

Hamburger.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Hamburger;

Hamburger.default = Hamburger;
